import { type AnyChainflipAsset } from '@chainflip/utils/chainflip';
import { TokenLogo } from '@/shared/components/logo/TokenLogo';
import {
  DEFAULT_COMBO_SIZE,
  TokenWithChainByAsset,
  type TokenWithChainSize,
} from '@/shared/components/logo/TokenWithChain';

const styles = {
  small: {
    container: { width: 22.65, height: 22 },
    token: { width: 15.8, height: 15.8 },
  },
  medium: {
    container: { width: 34.4, height: 28 },
    token: { width: 22.5, height: 22.5 },
  },
  large: {
    container: { width: 42.1, height: 35 },
    token: { width: 24, height: 24 },
  },
};

function AssetPoolLogo({
  asset,
  size = DEFAULT_COMBO_SIZE,
}: {
  asset: AnyChainflipAsset;
  size?: TokenWithChainSize;
}): React.JSX.Element {
  return (
    <div className="relative" style={styles[size].container}>
      <div className="absolute bottom-0 left-0 z-20">
        <TokenWithChainByAsset asset={asset} size={size} />
      </div>
      <div className="absolute right-0 top-0 z-10">
        <TokenLogo token="Usdc" props={styles[size].token} />
      </div>
    </div>
  );
}

export default AssetPoolLogo;
